import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"flat":""}},[_c('div',{ref:"paymentchart"}),_c(VCardTitle,{staticClass:"d-flex align-center justify-center"},[_vm._v("Payments Analytics")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }